import { useMemo } from "react";
import type { BasePropertyListingProps } from "./BasePropertyListing";
import { useSelectedPropertiesState } from "./selectedPropertiesAtom";

export const useCheckboxListing = (id: BasePropertyListingProps["id"]) => {
    const [selectedProperties, setSelectedProperties] = useSelectedPropertiesState();

    const isSelected = useMemo(() => selectedProperties.includes(id), [selectedProperties, id]);

    const toggle = () => {
        // if the property is already selected, remove it from the list
        if (isSelected) setSelectedProperties((prev) => prev.filter((selId) => selId !== id));
        // otherwise, add it to the list
        else setSelectedProperties((prev) => [...prev, id]);
    };

    return {
        isSelected,
        toggle,
    };
};
